/**
 * Draft persistence for long-text inputs (PLAN.md §5.10).
 *
 * A half-written reply is real work. It has to survive a closed tab, a browser crash and the
 * offline moment the PWA story (§5.27) expects — none of which give the app a chance to save on
 * the way out, so drafts are written as you type rather than on unload.
 *
 * `localStorage` rather than the server: a draft is per-device and per-browser by nature, and
 * round-tripping every keystroke to the API to store text the user hasn't chosen to send yet
 * would be both slower and a worse privacy default.
 */

const PREFIX = 'draft:';

export function loadDraft(key: string): string | null {
  try {
    return localStorage.getItem(PREFIX + key);
  } catch {
    // Storage is unavailable in private-mode Safari and when a quota is exhausted. Losing
    // draft persistence is acceptable; breaking the editor is not.
    return null;
  }
}

export function saveDraft(key: string, value: string): void {
  try {
    localStorage.setItem(PREFIX + key, value);
  } catch {
    /* see loadDraft */
  }
}

/** Call after a successful submit, so the sent text doesn't reappear as a draft. */
export function clearDraft(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    /* see loadDraft */
  }
}
